import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=2f7b7dd6&scoped=true"
import script from "./goodsTag.vue?vue&type=script&lang=js"
export * from "./goodsTag.vue?vue&type=script&lang=js"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=2f7b7dd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b7dd6",
  null
  
)

export default component.exports